import { render, staticRenderFns } from "./ChangeList.vue?vue&type=template&id=ceffbdd8"
import script from "./ChangeList.vue?vue&type=script&lang=js"
export * from "./ChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports